import React, { useState, useEffect, useRef } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { BsStopwatch } from 'react-icons/bs';
import Navbar from './navbar';
import Sidebar from './sidebar';
import useAuth from './useAuth';
import { FaArrowAltCircleLeft, FaArrowAltCircleRight } from 'react-icons/fa';
import { Button } from 'react-bootstrap';
import axios from 'axios';

const Resulat_qcm = () => {
    useAuth();
    const navigate = useNavigate();
    const location = useLocation();
    const user_id = localStorage.getItem('user_id');
    const [qcms, setQcms] = useState([]);
    const [simulation, setSimulation] = useState([]);
    const [total_questions, setTotal_questions] = useState([]);
    const [showConfetti, setShowConfetti] = useState(false);
    const resultsContainerRef = useRef(null);


    const [filteredQcms, setFilteredQcms] = useState([]);
    const [results, setResults] = useState([]);

    const evaluation_id = location.state?.evaluation_id;

    const [windowDimensions, setWindowDimensions] = useState({
        width: window.innerWidth,
        height: window.innerHeight,
    });

    useEffect(() => {
        if (simulation.pourcentage > 50) {
            setShowConfetti(true);
            const timer = setTimeout(() => setShowConfetti(false), 5000);
            return () => clearTimeout(timer);
        }
    }, [simulation.pourcentage]);

    useEffect(() => {
        const handleResize = () => {
            setWindowDimensions({
                width: window.innerWidth,
                height: window.innerHeight,
            });
        };
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    useEffect(() => {
        if (user_id) {
            document.title = "eTrainApp | Terminer";
        }
    }, [user_id]);

    useEffect(() => {
        if (evaluation_id) {
            const fetchSimulationsQcm = async () => {
                try {
                    const response = await fetch(`${process.env.REACT_APP_HOTE}/recuperer-evaluation-qcms/${user_id}/${evaluation_id}/`);
                    if (response.ok) {
                        const data = await response.json();
                        // ✅ Après
                        const isQcmTraite = (qcm) => {
                            const r = qcm.resultat;
                            if (r === undefined || r === null) return false;
                            if (Array.isArray(r)) return r.length > 0;
                            if (typeof r === 'object') return Object.keys(r).length > 0;
                            if (typeof r === 'string') return r.trim().length > 0;
                            return false;
                        };

                        const qcmsWithResult = data.qcms.filter(isQcmTraite);
                        setQcms(qcmsWithResult);
                        setTotal_questions(data.qcms);
                    }
                } catch (error) {
                }
            };
            fetchSimulationsQcm();
        }
    }, [user_id, evaluation_id]);

    useEffect(() => {
        if (evaluation_id) {
            const fetchSimulations = async () => {
                try {
                    const response = await fetch(`${process.env.REACT_APP_HOTE}/recuperer-evaluation/${user_id}/${evaluation_id}/`);
                    if (response.ok) {
                        const data = await response.json();
                        setSimulation(data);
                    }
                } catch (error) {
                }
            };
            fetchSimulations();
        }
    }, [user_id, evaluation_id]);

    const isSuccessful = simulation.pourcentage > 50;

    const [currentPage, setCurrentPage] = useState(1);

    const scrollToTop = () => {
        if (resultsContainerRef.current) {
            resultsContainerRef.current.scrollIntoView({
                behavior: 'smooth',
                block: 'start'
            });
        }
    };

    useEffect(() => {
        scrollToTop();
    }, [currentPage]);

    // ============================================================
    // FONCTION POUR AFFICHER LES RÉSULTATS DES CORRESPONDANCES
    // ============================================================
    const renderCorrespondanceResultat = (qcm) => {
        try {
            let leftOptions = [];
            let rightOptions = [];

            // Parser option1
            if (typeof qcm.option1 === 'string') {
                try {
                    let option1Str = qcm.option1;
                    if (option1Str.startsWith('"') && option1Str.endsWith('"')) {
                        option1Str = option1Str.slice(1, -1);
                    }
                    option1Str = option1Str.replace(/""/g, '"');
                    leftOptions = JSON.parse(option1Str);
                    if (!Array.isArray(leftOptions)) leftOptions = [];
                } catch (e) {
                    leftOptions = [];
                }
            } else if (Array.isArray(qcm.option1)) {
                leftOptions = qcm.option1;
            }

            // Parser option2
            if (typeof qcm.option2 === 'string') {
                try {
                    let option2Str = qcm.option2;
                    if (option2Str.startsWith('"') && option2Str.endsWith('"')) {
                        option2Str = option2Str.slice(1, -1);
                    }
                    option2Str = option2Str.replace(/""/g, '"');
                    rightOptions = JSON.parse(option2Str);
                    if (!Array.isArray(rightOptions)) rightOptions = [];
                } catch (e) {
                    rightOptions = [];
                }
            } else if (Array.isArray(qcm.option2)) {
                rightOptions = qcm.option2;
            }

            // Parser reponseCorrecte
            let reponseCorrecte = {};
            if (Array.isArray(qcm.reponse)) {
                try {
                    let fullStr = qcm.reponse.join('');
                    fullStr = fullStr.replace(/""/g, '"');
                    fullStr = fullStr.replace(/^["']|["']$/g, '');
                    const regex = /"(\d+)":\s*(\d+)/g;
                    let match;
                    while ((match = regex.exec(fullStr)) !== null) {
                        reponseCorrecte[parseInt(match[1])] = parseInt(match[2]);
                    }
                } catch (e) {
                    console.error('Erreur parsing reponse:', e);
                }
            } else if (typeof qcm.reponse === 'string') {
                try {
                    let cleanStr = qcm.reponse;
                    cleanStr = cleanStr.replace(/""/g, '"');
                    cleanStr = cleanStr.replace(/^["']|["']$/g, '');
                    const parsed = JSON.parse(cleanStr);
                    if (typeof parsed === 'object' && !Array.isArray(parsed)) {
                        reponseCorrecte = parsed;
                    }
                } catch (e) {
                    console.error('Erreur parsing reponse (string):', e);
                }
            } else if (typeof qcm.reponse === 'object' && !Array.isArray(qcm.reponse)) {
                reponseCorrecte = qcm.reponse;
            }

            const reponseUtilisateur = qcm.resultat || {};

            // Vérifier si la correspondance est correcte
            const isCorrect = (() => {
                if (Object.keys(reponseUtilisateur).length === 0) return false;
                for (const key of Object.keys(reponseCorrecte)) {
                    if (!(key in reponseUtilisateur) || reponseUtilisateur[key] !== reponseCorrecte[key]) {
                        return false;
                    }
                }
                return true;
            })();

            if (leftOptions.length === 0 || rightOptions.length === 0) {
                return <div className="text-danger">Données de correspondance manquantes</div>;
            }

            return (
                <div style={{ margin: '10px 10px' }}>
                    <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                        <thead>
                            <tr>
                                <th style={{ textAlign: 'left', padding: '5px', borderBottom: '2px solid #dee2e6' }}>Items à associer</th>
                                <th style={{ textAlign: 'left', padding: '5px', borderBottom: '2px solid #dee2e6' }}>Réponse donnée</th>
                                <th style={{ textAlign: 'left', padding: '5px', borderBottom: '2px solid #dee2e6' }}>Statut</th>
                            </tr>
                        </thead>
                        <tbody>
                            {leftOptions.map((leftItem) => {
                                const leftId = leftItem.id;
                                const userPair = reponseUtilisateur[leftId];
                                const correctPair = reponseCorrecte[leftId];

                                let userValue = 'Non sélectionné';
                                if (userPair) {
                                    const found = rightOptions.find(r => r.id === userPair);
                                    userValue = found ? found.value : 'Non sélectionné';
                                }

                                const isItemCorrect = userPair && userPair === correctPair;

                                return (
                                    <tr key={leftId} style={{ borderBottom: '1px solid #e9ecef' }}>
                                        <td style={{ padding: '8px 5px', verticalAlign: 'middle' }}>
                                            <span style={{ fontWeight: '500' }}>{leftItem.value || `Item ${leftId}`}</span>
                                        </td>
                                        <td style={{ padding: '8px 5px', verticalAlign: 'middle' }}>
                                            <span>{userValue}</span>
                                        </td>
                                        <td style={{ padding: '8px 5px', verticalAlign: 'middle' }}>
                                            {userPair ? (
                                                isItemCorrect ? (
                                                    <i className="fa fa-thumbs-up" style={{ color: 'green', fontSize: '20px' }} title="Correct"></i>
                                                ) : (
                                                    <i className="fa fa-thumbs-down" style={{ color: 'red', fontSize: '20px' }} title="Incorrect"></i>
                                                )
                                            ) : (
                                                <i className="fa fa-minus-circle" style={{ color: 'orange', fontSize: '20px' }} title="Non répondu"></i>
                                            )}
                                        </td>
                                    </tr>
                                );
                            })}
                        </tbody>
                    </table>

                    {/* VOTRE RÉPONSE AVEC BADGE */}
                    <div style={{ marginTop: '10px', display: 'flex', alignItems: 'center', gap: '8px', flexWrap: 'wrap', justifyContent: 'right' }}>

                        <span style={{
                            padding: '2px 3px',
                            borderRadius: '4px',
                            fontWeight: 'bold',
                            fontSize: '12px',
                            backgroundColor: isCorrect ? '#28a745' : '#dc3545',
                            color: 'white',
                            display: 'inline-block',
                            marginLeft: '5px',
                            justifyContent: "end"
                        }}>
                            {isCorrect ? '✅ Correct' : '❌ Incorrect'}
                        </span>
                    </div>



                    {/* EXPLICATION */}
                    {qcm.explication && qcm.explication !== 'non défini' && (
                        <div style={{ color: 'green', marginTop: '5px', fontSize: '13px' }}>
                            <strong>Explication :</strong>{' '}
                            <span dangerouslySetInnerHTML={{ __html: qcm.explication }} />
                        </div>
                    )}
                </div>
            );
        } catch (e) {
            console.error('Erreur rendu correspondance:', e);
            return <div className="text-danger">Erreur d'affichage des correspondances</div>;
        }
    };

    // ============================================================
    // FIN FONCTION CORRESPONDANCE
    // ============================================================


    const itemsParPage = 5;
    const totalPages = Math.ceil(qcms.length / itemsParPage);
    const debutIndex = (currentPage - 1) * itemsParPage;
    const finIndex = debutIndex + itemsParPage;
    const currentQcms = qcms.slice(debutIndex, finIndex);

    const pageSuivante = () => {
        if (currentPage < totalPages) {
            setCurrentPage(currentPage + 1);
        }
    };

    const pagePrecedente = () => {
        if (currentPage > 1) {
            setCurrentPage(currentPage - 1);
        }
    };

    const [accesGroupe, setAccesGroupe] = useState([]);
    const [groupeId, setGroupeId] = useState(null);
    const groupe = localStorage.getItem('groupe');

    const verifGroupe = async () => {
        const groupeStored = localStorage.getItem('groupe');
        const accesGroupeStored = localStorage.getItem('accesGroupe');

        if (groupeStored && accesGroupeStored) {
            setGroupeId(groupeStored);
            setAccesGroupe(JSON.parse(accesGroupeStored));
        } else {
            try {
                const response = await axios.get(`${process.env.REACT_APP_HOTE}/verif-groupe/${user_id}/${groupe}`);
                if (response.status === 200) {
                    const data = response.data;
                    setGroupeId(data.groupe);

                    let cleanedAccessArray = [];
                    if (Array.isArray(data.acces)) {
                        cleanedAccessArray = data.acces.map((item) =>
                            item.acces
                                ? item.acces.replace(/[\[\]']/g, '').trim().split(',').map((access) => access.trim())
                                : []
                        ).flat();

                        setAccesGroupe(cleanedAccessArray);
                    }

                    localStorage.setItem('groupe', data.groupe);
                    localStorage.setItem('accesGroupe', JSON.stringify(cleanedAccessArray));
                }
            } catch (error) {
                // console.error('Erreur lors de la vérification du groupe', error);
            }
        }
    };

    useEffect(() => {
        if (user_id) {
            verifGroupe();
        }
    }, [user_id]);

    // ============================================================
    // FONCTION POUR AFFICHER LES QUESTIONS PAR DÉFAUT (AVEC BADGE)
    // ============================================================
    const renderQuestionDefaut = (qcm) => {
        const userAnswers = Array.isArray(qcm.resultat) ? qcm.resultat : [];
        const correctAnswers = Array.isArray(qcm.reponse) ? qcm.reponse : [];
        const isCorrect = userAnswers.length > 0 &&
            JSON.stringify([...userAnswers].sort()) === JSON.stringify([...correctAnswers].sort());

        return (
            <>
                <div style={{ margin: '10px 10px' }}>
                    {Object.keys(qcm)
                        .filter((key) => key.startsWith('option') && qcm[key] && (qcm[key] !== 'non défini' && qcm[key] !== 'vide'))
                        .map((key, optionIndex) => {
                            const optionLetter = String.fromCharCode(65 + optionIndex);
                            const optionText = qcm[key];
                            const isCorrectAnswer = Array.isArray(qcm.reponse) && qcm.reponse.includes(optionLetter);
                            const isUserAnswer = Array.isArray(qcm.resultat) && qcm.resultat.includes(optionLetter);

                            let bgColor = 'transparent';
                            if (isUserAnswer && isCorrectAnswer) {
                                bgColor = '#d4edda';
                            } else if (isUserAnswer && !isCorrectAnswer) {
                                bgColor = '#f8d7da';
                            } else if (!isUserAnswer && isCorrectAnswer) {
                                bgColor = '#e8f5e9';
                            }

                            return (
                                <div key={key} style={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    marginBottom: '8px',
                                    fontSize: '12px',
                                    padding: '5px 10px',
                                    borderRadius: '4px',
                                    backgroundColor: bgColor,
                                    border: isUserAnswer && isCorrectAnswer ? '1px solid #28a745' :
                                        isUserAnswer && !isCorrectAnswer ? '1px solid #dc3545' : '1px solid transparent'
                                }}>
                                    <span style={{ marginRight: '10px', minWidth: '25px', fontWeight: 'bold' }}>
                                        {optionLetter} -
                                    </span>
                                    <span style={{ flex: 1 }}>
                                        {optionText}
                                    </span>
                                    {isCorrectAnswer && isUserAnswer ? (
                                        <i className="fa fa-check-circle" style={{ color: 'green', fontSize: '18px' }} title="Bonne réponse sélectionnée"></i>
                                    ) : isCorrectAnswer ? (
                                        <i className="fa fa-circle-o" style={{ color: '#6c757d', fontSize: '16px' }} title="Bonne réponse non sélectionnée"></i>
                                    ) : isUserAnswer ? (
                                        <i className="fa fa-times-circle" style={{ color: 'red', fontSize: '18px' }} title="Mauvaise réponse sélectionnée"></i>
                                    ) : null}
                                </div>
                            );
                        })}
                </div>

                {/* VOTRE RÉPONSE AVEC BADGE */}
                <div style={{ marginTop: '10px', display: 'flex', alignItems: 'center', gap: '8px', flexWrap: 'wrap', justifyContent: 'space-between' }}>
                    <span style={{ fontWeight: 'bold', fontSize: '13px' }}>Votre réponse : {userAnswers.length > 0 ? userAnswers.join(', ') : 'Aucune réponse'}</span>

                    <span style={{
                        padding: '2px 10px',
                        borderRadius: '4px',
                        fontWeight: 'bold',
                        fontSize: '12px',
                        backgroundColor: isCorrect ? '#28a745' : '#dc3545',
                        color: 'white',
                        display: 'inline-block',
                        marginLeft: '5px',
                        justifyContent: 'space-between'
                    }}>
                        {isCorrect ? '✅ Correct' : '❌ Incorrect'}
                    </span>
                </div>

                {/* BONNES RÉPONSES */}
                <div style={{ marginTop: '5px', fontStyle: 'italic', color: 'blue', fontSize: '13px' }}>
                    <strong>Bonnes réponses :</strong> {qcm.reponse && Array.isArray(qcm.reponse) ? qcm.reponse.join(' , ') : 'Aucune'}
                </div>

                {/* EXPLICATION */}
                {qcm.explication && qcm.explication !== 'non défini' && (
                    <div style={{ color: 'green', marginTop: '5px', fontSize: '13px' }}>
                        <strong>Explication :</strong>{' '}
                        <span dangerouslySetInnerHTML={{ __html: qcm.explication }} />
                    </div>
                )}
            </>
        );
    };

    return (
        <div id="wrapper">
            <Sidebar user_id={user_id} />
            <div id="page-wrapper" className="gray-bg">
                <Navbar />
                <div>
                    <div className="row wrapper border-bottom white-bg page-heading">
                        <div className="col-lg-12">
                            <h2><BsStopwatch size={25} className='mr-2' />Evaluation</h2>
                            <small>
                                Résultat et correction de l'Evaluation. Les explications et les éventuelles références au Guide PMBOK aident à mieux comprendre la logique des questions. <br /><b>Légende des icônes : </b>
                                <i className="fa fa-thumbs-o-up ivt-align-menu"></i> indique la bonne réponse,
                                <i className="fa fa-thumbs-o-down ivt-align-menu"></i> indique la mauvaise réponse.
                            </small>
                            <small id='hbreadcrumb' className='d-flex justify-content-end'>
                                <ol className="breadcrumb custom-breadcrumb">
                                    <li className="breadcrumb-item custom-breadcrumb-item">
                                        <Link to={`/Parcours`}>Parcours</Link>
                                    </li>
                                    <li className="breadcrumb-item custom-breadcrumb-item">
                                        {evaluation_id}
                                    </li>
                                </ol>
                            </small>
                        </div>
                    </div>

                    <div className="wrapper wrapper-content animated fadeInRight mt-3">
                        <div className="row d-flex justify-content-center">
                            <div className="col-lg-8 mx-auto">
                                <div className="ibox">
                                    <div className="ibox-title pr-3">
                                        <h5>Résultats</h5>
                                        <div className="table-responsive">
                                            <table className="table table-striped table-hover">
                                                <tbody>
                                                    <tr>
                                                        <td>Questions traitées : </td>
                                                        <td>{qcms.length} sur {total_questions.length}</td>
                                                    </tr>
                                                    <tr>
                                                        <td>Bonnes réponses : </td>
                                                        <td>
                                                            <div className="progress m-t-xs full">
                                                                <div
                                                                    className="progress-bar progress-bar-success"
                                                                    role="progressbar"
                                                                    aria-valuemin="0"
                                                                    aria-valuemax="100"
                                                                    aria-valuenow={simulation.pourcentage}
                                                                    style={{ width: `${simulation.pourcentage}%` }}
                                                                >
                                                                    <span className={simulation.pourcentage === 0 && 'text-dark'}>
                                                                        {simulation.pourcentage}%
                                                                    </span>
                                                                </div>
                                                            </div>
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                    <div className="ibox-content text-dark" ref={resultsContainerRef}>
                                        {currentQcms.length > 0 ? (
                                            currentQcms.map((qcm) => (
                                                <div key={qcm.id} style={{ borderBottom: '1px solid #ccc', paddingBottom: '15px', marginBottom: '15px' }}>
                                                    <input type="hidden" name="qcmidhidden" id="qcmidhidden" value={qcm.id} />
                                                    <div>
                                                        <span># {qcm.ref} - </span>
                                                        <span
                                                            id="question"
                                                            style={{ fontSize: '13px' }}
                                                            dangerouslySetInnerHTML={{ __html: qcm.question }}
                                                        ></span>
                                                    </div>

                                                    {/* Affichage selon le type de question */}
                                                    {qcm.type_question === 'correspondance' ? (
                                                        renderCorrespondanceResultat(qcm)
                                                    ) : (
                                                        renderQuestionDefaut(qcm)
                                                    )}
                                                </div>
                                            ))
                                        ) : (
                                            <p>Aucun QCM avec résultat trouvé pour cette simulation.</p>
                                        )}

                                        {/* Pagination */}
                                        {totalPages > 1 && (
                                            <div className="d-flex align-items-center mt-4 mb-4">
                                                {currentPage > 1 && (
                                                    <Button className="btn btn-success me-2" onClick={pagePrecedente}>
                                                        <FaArrowAltCircleLeft />
                                                    </Button>
                                                )}
                                                <span className="flex-grow-1 text-center">Page {currentPage} sur {totalPages}</span>
                                                {currentPage < totalPages && (
                                                    <Button className="btn btn-success ms-2" onClick={pageSuivante}>
                                                        <FaArrowAltCircleRight />
                                                    </Button>
                                                )}
                                            </div>
                                        )}

                                        <div className="d-flex justify-content-end mt-4">
                                            <Button
                                                className='btn btn-success d-flex align-items-center justify-between'
                                                onClick={() => navigate('/Parcours')}
                                            >
                                                <FaArrowAltCircleLeft className='mr-1' />
                                                <span className="d-none d-sm-inline">
                                                    Retour à mon parcours
                                                </span>
                                            </Button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Resulat_qcm;